import { type FC } from "react";

import { Stack } from "@mantine/core";

import { useFeatureGates } from "../../cof-feature-gates/hooks";
import { CofConfigId } from "../../gql-generated/types";
import { PayoutDriversCard } from "../../lens-creator-payout/components/PayoutDriversCard";

import { HomeEngagementReachCard } from "./HomeEngagementReachCard";
import { HomeMonetizationBanner } from "./HomeMonetizationBanner";

export const HomeStatsRow: FC = () => {
    const { configs } = useFeatureGates();
    const isMonetizationEnabled = configs[CofConfigId.MyLensesMonetizationInsights].enabled;

    return (
        <Stack gap="lg">
            {isMonetizationEnabled ? <HomeMonetizationBanner /> : <PayoutDriversCard />}
            <HomeEngagementReachCard />
        </Stack>
    );
};
